<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <img class="icon" src="../../../assets/images/mail-icon.svg">
    <span class="title ms-2">Modifier mes coordonnées bancaires</span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content">
  <p class="mt-4">
    Pour mettre à jour vos coordonnées bancaires, téléchargez le mandat de prélèvement, remplissez le et renvoyez avec le formulaire ci-dessous.
  </p>
  <button class="button m mt-3 expand" type="button">Télécharger le mandat de prélèvement</button>
  <form [formGroup]="bankInformationsForm" class="d-flex flex-column gap-3 w-100 mt-5">
    <div class="d-flex flex-column gap-2 form-group w-100" id="uploader">
      <label>Mandat de prélèvement</label>
      <app-file-uploader (onFilesAdded)="addFiles($event)" [multipleSelection]="false"></app-file-uploader>
      <div class="list" *ngIf="bankInformationsForm.value.file">
        <div class="content">
          <div class="item d-flex flex-row align-items-center justify-content-between">
            <span class="name">{{ bankInformationsForm.value.file.name }}</span>
            <div class="d-flex flex-row align-items-center">
              <button class="button m icon transparent" (click)="removeFile()"><i class="ti ti-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button m primary mt-3 expand" type="button">Envoyer le mandat</button>
  </form>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Fermer</button>
</div>
